module.exports = __webpack_public_path__ + "img/giving-heart.57ced3d3.png";